import { render, staticRenderFns } from "./CategoriaSeleccionComponent.vue?vue&type=template&id=76e456c2&"
import script from "./CategoriaSeleccionComponent.vue?vue&type=script&lang=js&"
export * from "./CategoriaSeleccionComponent.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaSeleccionComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports